import axios from 'axios'
import APIConfig from '../remote/APIConfig.js'

export default class WebInfoService {
  constructor () {
    this.apis = {
      getAll: () => axios.get(APIConfig.BPIURL + '/webInfo'),
      add: (payload) => axios.post(APIConfig.BPIURL + '/webInfo', payload),
      edit: (id, payload) => axios.put(APIConfig.BPIURL + `/webInfo/${id}`, payload),
      delete: (id) => axios.delete(APIConfig.BPIURL + `/webInfo/${id}`)
    }
  }

  getAll (vm) {
    vm.isLoading = true
    return this.apis.getAll()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  add (vm, payload) {
    vm.isLoading = true
    return this.apis.add(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  edit (vm, payload) {
    vm.isLoading = true
    return this.apis.edit(payload.ID, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  delete (vm, id) {
    vm.isLoading = true
    return this.apis.delete(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}
